import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SinglePaneelProps extends ConfigurationProps {}
const SinglePaneel = ({
  materials,
  position,
  scale,
  doorSettings,
}: SinglePaneelProps) => {
  const { sceneStaanderPosition } = useConfigurationOptionsContext();

  return (
    <group scale={scale}>
      <Paneel
        materials={materials}
        position={position}
        frameSettings={doorSettings?.main?.frameSettings}
        verticalBeamPosition={sceneStaanderPosition}
      />
    </group>
  );
};

export default SinglePaneel;
